export default __webpack_public_path__ + "static/media/finesse-single-logo.b3387577.png";